import { KindRootNodeStoreProvider } from '../Store'

import { KindRootNodeSelectCore } from './Core'
import { KindRootNodeSelectProps } from './interface'

export const KindRootNodeSelect = <M extends boolean = true>({
  /* -------------------------------------------------------------------------- */
  /*                        KindRootNodeSelectCore Props                        */
  /* -------------------------------------------------------------------------- */
  allowClear,
  disabled,
  placeholder,

  /* -------------------------------------------------------------------------- */
  /*                       KindRootNodeStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  ...providerProps
}: KindRootNodeSelectProps<M>) => {
  return (
    <KindRootNodeStoreProvider {...providerProps}>
      <KindRootNodeSelectCore
        allowClear={allowClear}
        disabled={disabled}
        placeholder={placeholder}
      />
    </KindRootNodeStoreProvider>
  )
}
